import PropTypes from "prop-types";
import * as React from "react";
import {
  PASSWORD_RULE_MESSAGE,
  isPassword,
  normalizePassword,
} from "../../../shared/auth/password.js";
import { authenticate, messageOf } from "../../services/auth";
import { Alert, Box, Button, TextInput } from "../../themeV2";

const fieldProblems = ({ email, password }) => ({
  email: email.trim() ? null : "Please enter your email address",
  password: !normalizePassword(password)
    ? "Please enter your password"
    : !isPassword(normalizePassword(password))
    ? PASSWORD_RULE_MESSAGE
    : null,
});

const hasProblem = (problems) => Object.values(problems).some(Boolean);

export default function CreateAccountForm({ onAnswered }) {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [problems, setProblems] = React.useState({});
  const [failure, setFailure] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const checked = fieldProblems({ email, password });
    setProblems(checked);
    setFailure(null);

    if (hasProblem(checked) || isSubmitting) return;

    setIsSubmitting(true);
    const result = await authenticate({
      mode: "create",
      email: email.trim(),
      password: normalizePassword(password),
    });
    setIsSubmitting(false);

    return result.ok
      ? onAnswered({ body: result.data, email: email.trim() })
      : setFailure(messageOf(result));
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Box direction="column" gap={4}>
        <TextInput
          type="email"
          label="Email"
          variant="filled"
          autoComplete="email"
          autoFocus
          required
          value={email}
          onValueChange={setEmail}
          error={problems.email ?? undefined}
        />

        <TextInput
          type="password"
          label="Password"
          variant="filled"
          autoComplete="new-password"
          required
          value={password}
          onValueChange={setPassword}
          description={PASSWORD_RULE_MESSAGE}
          error={problems.password ?? undefined}
        />

        {failure && <Alert severity="error">{failure}</Alert>}

        <Button type="submit" fullWidth loading={isSubmitting}>
          Create Account
        </Button>
      </Box>
    </form>
  );
}

CreateAccountForm.propTypes = {
  onAnswered: PropTypes.func.isRequired,
};
